export const  animateScroll = (el, time, offset = false) => {
    $('html, body').animate({
        scrollTop: offset ? offset : el.offset().top
    }, time);
}
